<template>
  <v-app-bar
    v-if="loggedIn"
    dark
    color="accent"
    app
    fixed
    dense
    class="time-position d-flex justify-center"
  >
    {{ time }}
  </v-app-bar>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      date: moment()
    };
  },
  computed: {
    ...mapState("user", ["loggedIn"]),
    time: function() {
      return this.date.format("DD MMMM YYYY hh:mm:ss");
    }
  },
  mounted() {
    setInterval(() => {
      this.date = moment(this.date.subtract(1, "seconds"));
    }, 1000);
  }
};
</script>

<style>
.time-position {
  transform: translateY(48px) !important;
}
</style>
